(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["worn-rail"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Shared fullscreen player. Tapping a video card opens the clip full-size with a
  // clean custom UI: tap to play/pause, a mute toggle, a progress bar, and prev/next
  // (arrows, arrow keys, or swipe) to move between clips without closing. Opens with
  // sound on. One overlay is built once and reused for every rail.
  var _wlb = null, _wlbList = [], _wlbIdx = 0;
  function _wlbClose() {
    if (!_wlb) return;
    _wlb.classList.remove('is-open');
    var v = _wlb.__v; try { v.pause(); } catch (e) {}
    v.removeAttribute('src'); v.load();
    document.documentElement.style.overflow = ''; document.body.style.overflow = '';
  }
  function _wlbGo(d) { var n = _wlbIdx + d; if (n < 0 || n >= _wlbList.length) return; _wlbIdx = n; _wlbLoad(); }
  function _wlbLoad() {
    var it = _wlbList[_wlbIdx]; if (!it) return;
    var v = _wlb.__v;
    v.src = it.src; v.muted = false; _wlb.__fill.style.width = '0%';
    _wlb.querySelector('.worn-lb__cap').textContent = it.label || '';
    _wlb.querySelector('.worn-lb__nav--prev').style.visibility = _wlbIdx > 0 ? 'visible' : 'hidden';
    _wlb.querySelector('.worn-lb__nav--next').style.visibility = _wlbIdx < _wlbList.length - 1 ? 'visible' : 'hidden';
    _wlb.__syncMute();
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function _wlbEnsure() {
    if (_wlb) return;
    _wlb = document.createElement('div');
    _wlb.className = 'worn-lb';
    _wlb.innerHTML =
      '<button type="button" class="worn-lb__close" aria-label="close">×</button>' +
      '<button type="button" class="worn-lb__nav worn-lb__nav--prev" aria-label="previous clip">‹</button>' +
      '<button type="button" class="worn-lb__nav worn-lb__nav--next" aria-label="next clip">›</button>' +
      '<div class="worn-lb__stage">' +
        '<div class="worn-lb__frame">' +
          '<video class="worn-lb__video" playsinline webkit-playsinline preload="auto"></video>' +
          '<span class="worn-lb__big" aria-hidden="true"><svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>' +
        '</div>' +
        '<div class="worn-lb__bar">' +
          '<button type="button" class="worn-lb__mute" aria-label="toggle sound"></button>' +
          '<div class="worn-lb__track"><span class="worn-lb__fill"></span></div>' +
        '</div>' +
        '<span class="worn-lb__cap"></span>' +
      '</div>';
    document.body.appendChild(_wlb);
    var v = _wlb.querySelector('.worn-lb__video');
    var fill = _wlb.querySelector('.worn-lb__fill');
    var track = _wlb.querySelector('.worn-lb__track');
    var muteBtn = _wlb.querySelector('.worn-lb__mute');
    var frame = _wlb.querySelector('.worn-lb__frame');
    var spkOn = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4z" fill="currentColor" stroke="none"/><path d="M15.5 8.5a5 5 0 010 7"/></svg>';
    var spkOff = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4z" fill="currentColor" stroke="none"/><path d="M22 9l-6 6M16 9l6 6"/></svg>';
    function syncMute() { muteBtn.innerHTML = v.muted ? spkOff : spkOn; }
    function togglePlay() { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }
    frame.addEventListener('click', togglePlay);
    v.addEventListener('play', function () { _wlb.classList.remove('is-paused'); });
    v.addEventListener('pause', function () { _wlb.classList.add('is-paused'); });
    v.addEventListener('timeupdate', function () { if (v.duration) fill.style.width = (v.currentTime / v.duration * 100) + '%'; });
    v.addEventListener('ended', function () { if (_wlbIdx < _wlbList.length - 1) _wlbGo(1); else _wlb.classList.add('is-paused'); });
    muteBtn.addEventListener('click', function (e) { e.stopPropagation(); v.muted = !v.muted; syncMute(); });
    track.addEventListener('click', function (e) { e.stopPropagation(); var r = track.getBoundingClientRect(); var f = (e.clientX - r.left) / r.width; if (v.duration) v.currentTime = Math.max(0, Math.min(1, f)) * v.duration; });
    _wlb.querySelector('.worn-lb__close').addEventListener('click', _wlbClose);
    _wlb.querySelector('.worn-lb__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); _wlbGo(-1); });
    _wlb.querySelector('.worn-lb__nav--next').addEventListener('click', function (e) { e.stopPropagation(); _wlbGo(1); });
    _wlb.addEventListener('click', function (e) { if (e.target === _wlb) _wlbClose(); });
    document.addEventListener('keydown', function (e) {
      if (!_wlb.classList.contains('is-open')) return;
      if (e.key === 'Escape' || e.keyCode === 27) _wlbClose();
      else if (e.key === 'ArrowRight') _wlbGo(1);
      else if (e.key === 'ArrowLeft') _wlbGo(-1);
    });
    var sx = null;
    frame.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    frame.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 45) _wlbGo(dx < 0 ? 1 : -1); sx = null; });
    _wlb.__v = v; _wlb.__fill = fill; _wlb.__syncMute = syncMute;
  }
  function openWornLightbox(list, idx) {
    if (!list || !list.length) return;
    _wlbEnsure();
    _wlbList = list; _wlbIdx = idx || 0;
    _wlb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
    _wlbLoad();
  }

  function initRail(rail) {
    if (rail.__wornInit) return;
    rail.__wornInit = true;
    var track = rail.querySelector('[data-worn-track]');
    if (!track) return;
    var realCards = Array.prototype.slice.call(track.querySelectorAll('[data-worn-card]'));
    var N = realCards.length;
    if (!N) return;

    // ── Infinite loop ──────────────────────────────────────────────
    // Clone one full set of cards before AND after the real set so the rail
    // cycles endlessly in both directions. The real set stays in the middle;
    // once a swipe/arrow settles inside a clone zone we teleport the scroll
    // position back by exactly one set-width. Clones are pixel-identical, so
    // the teleport is invisible — reaching the end just flows into the start.
    var loop = N >= 2;
    realCards.forEach(function (c, i) { c.setAttribute('data-loop-i', i); });
    var allCards = realCards.slice();
    if (loop) {
      var pre = document.createDocumentFragment();
      var post = document.createDocumentFragment();
      realCards.forEach(function (c) {
        [pre, post].forEach(function (frag) {
          var cl = c.cloneNode(true);
          cl.setAttribute('data-worn-clone', 'true');
          cl.setAttribute('aria-hidden', 'true');
          var foc = cl.querySelectorAll('a, button');
          for (var j = 0; j < foc.length; j++) foc[j].setAttribute('tabindex', '-1');
          frag.appendChild(cl);
        });
      });
      track.insertBefore(pre, realCards[0]);
      track.appendChild(post);
      allCards = Array.prototype.slice.call(track.querySelectorAll('[data-worn-card]'));
    }

    var dotsWrap = rail.querySelector('[data-worn-dots]');
    var dots = [];

    function stride() {
      return allCards.length > 1 ? (allCards[1].offsetLeft - allCards[0].offsetLeft) : (allCards[0].offsetWidth || 1);
    }
    // Which card is nearest the viewport CENTRE (the one we scale up as
    // "selected"). Measured from live rects, so it's correct regardless of the
    // track's offsetParent / padding.
    function centeredIndex() {
      var trc = track.getBoundingClientRect();
      var r0 = allCards[0].getBoundingClientRect();
      var mid = trc.left + trc.width / 2;
      var c0 = r0.left + r0.width / 2;
      return Math.round((mid - c0) / stride());
    }
    // Scroll so card `idx` is centred in the viewport, by the exact measured
    // delta — no offset/padding assumptions.
    // Instantly reposition, bypassing the track's CSS scroll-behavior:smooth, so
    // loop teleports and the initial park never animate into a visible scroll.
    function jumpBy(px) {
      if (!px) return;
      var _sb = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft += px;
      void track.offsetWidth; // commit the jump before smooth is restored (Safari)
      track.style.scrollBehavior = _sb;
    }
    function scrollToIndex(idx, smooth) {
      var t = allCards[idx];
      if (!t) return;
      var trc = track.getBoundingClientRect(), cr = t.getBoundingClientRect();
      var delta = (cr.left + cr.width / 2) - (trc.left + trc.width / 2);
      if (smooth) track.scrollBy({ left: delta, behavior: 'smooth' });
      else jumpBy(delta);
    }

    // Park with the first real card CENTRED; a full set of clones sits on each
    // side to scroll into before we teleport.
    if (loop) scrollToIndex(N, false);

    if (dotsWrap) {
      for (var di = 0; di < N; di++) {
        (function (i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'worn-dot';
          d.setAttribute('aria-label', 'go to item ' + (i + 1));
          d.addEventListener('click', function () { scrollToIndex((loop ? N : 0) + i, true); });
          dotsWrap.appendChild(d);
          dots.push(d);
        })(di);
      }
    }

    // Once a scroll has settled, snap the position back into the middle set if
    // it drifted into a clone zone. Done on settle (not mid-momentum) so iOS
    // momentum scrolling isn't interrupted; the identical clones mean the jump
    // is never visible.
    function normalize() {
      if (!loop) return;
      var st = stride();
      if (st <= 0) return;
      var c = centeredIndex(), nc = c;
      while (nc < N) nc += N;
      while (nc >= 2 * N) nc -= N;
      // The teleport back into the real set MUST be instant — jumpBy bypasses
      // the track's CSS scroll-behavior:smooth so the rail never visibly scrolls
      // back to the start; identical clones are swapped for the real cards with
      // zero perceptible movement.
      if (nc !== c) jumpBy((nc - c) * st);
    }

    var raf = null, settleT = null;
    function updateActive() {
      var raw = centeredIndex();
      if (raw < 0) raw = 0;
      if (raw > allCards.length - 1) raw = allCards.length - 1;
      allCards.forEach(function (card, i) { card.classList.toggle('is-active', i === raw); });
      var realIdx = loop ? (((raw - N) % N) + N) % N : Math.max(0, Math.min(N - 1, raw));
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === realIdx); });
    }
    function onScroll() {
      if (!raf) raf = requestAnimationFrame(function () { raf = null; updateActive(); });
      if (settleT) clearTimeout(settleT);
      settleT = setTimeout(function () { normalize(); updateActive(); }, 90);
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', function () { normalize(); updateActive(); });
    window.addEventListener('resize', function () { normalize(); onScroll(); });

    var prev = rail.querySelector('[data-worn-prev]');
    var next = rail.querySelector('[data-worn-next]');
    function step(dir) { scrollToIndex(centeredIndex() + dir, true); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Video tap → open the lightbox at the correct REAL clip; a tapped clone
    // maps back to its original via data-loop-i.
    var videoRealCards = realCards.filter(function (c) { return c.getAttribute('data-type') === 'video'; });
    var playlist = videoRealCards.map(function (c) {
      var l = c.querySelector('.worn-card__label');
      return { src: c.getAttribute('data-video-mp4') || c.getAttribute('data-video-src'), label: l ? l.textContent.trim() : '' };
    });
    allCards.forEach(function (card) {
      var type = card.getAttribute('data-type');
      if (type === 'video') {
        var tap = card.querySelector('.worn-card__tap') || card;
        tap.addEventListener('click', function (e) {
          e.preventDefault();
          var li = parseInt(card.getAttribute('data-loop-i'), 10);
          var realCard = (li >= 0 && realCards[li]) ? realCards[li] : card;
          openWornLightbox(playlist, Math.max(0, videoRealCards.indexOf(realCard)));
        });
      } else if (type === 'review' && card.getAttribute('data-scroll-reviews') === 'true') {
        card.addEventListener('click', function (e) {
          var target = document.querySelector('.jdgm-review-widget, .judgeme-review-section, #reviews, [id^="judgeme"]');
          if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
      }
    });

    updateActive();
  }

  function observe(rail) {
    if (!('IntersectionObserver' in window)) { initRail(rail); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { initRail(rail); io.disconnect(); } });
    }, { rootMargin: '300px 0px' });
    io.observe(rail);
  }

  function boot() {
    var rails = document.querySelectorAll('[data-worn-rail]');
    for (var i = 0; i < rails.length; i++) observe(rails[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();
})();
